import { Component, Input, ViewChild } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseComponent } from '@base/component/BaseComponent';
import { BaseState } from '@base/entities/BaseEntities';
import { SignaturePad } from 'angular2-signaturepad';

class State {
    SignatureData: string;
    IsDrawing = false;
    Options: any;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-signbox',
    templateUrl: './signbox.component.html',
    styleUrls: ['./signbox.component.scss']
})
export class SignBoxComponent extends BaseComponent<State> {

    @ViewChild('pad') pad: SignaturePad;
    @Input() SignatureReadOnly: boolean;
    @Input() MaxSignatureHeight: number = 0;
    @Input() Options: any;

    private _clientHeight: number;
    @Input() set ClientHeight(value: number) {
        if (!value) return;
        this._clientHeight = value;
        this.ResizePad();
    }

    get ClientHeight() {
        return this._clientHeight;
    }

    private _clientWidth: number;
    @Input() set ClientWidth(value: number) {
        if (!value) return;
        this._clientWidth = value;
        this.ResizePad();
    }

    get ClientWidth() {
        return this._clientWidth;
    }

    public set SignatureData(value: string) {
        this.State.SignatureData = value;
        setTimeout(() => this.LoadSignature(), 100);
    }
    public get SignatureData(): string {
        return this.State.SignatureData;
    }

    private readonly _areaAroundSize = 180;

    constructor(A: ServiceBagService) {
        super(A, 'SignBoxComponent', State);
    }

    protected override OnInitComponent() {
        window.addEventListener('touchmove', this.OnTouchMove, { passive: false });
        window.addEventListener('touchstart', this.OnTouchMove, { passive: false });
    }

    protected override OnInitComponentFinished() {
        this.State.Options = this.Options ?? {};
        if (!this.State.Options.penColor) this.State.Options.penColor = '#0177F9';
        if (!this.State.Options.backgroundColor) this.State.Options.backgroundColor = '#ffffff';
        if (!this.State.Options.maxWidth) this.State.Options.maxWidth = 2;
    }

    protected override OnDestroyComponent() {
        window.removeEventListener('touchmove', this.OnTouchMove);
        window.removeEventListener('touchstart', this.OnTouchMove);
    }

    OnTouchMove = (e) => {
        if (!this.State.IsDrawing) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }

    OnBeginDrawing() {
        this.State.IsDrawing = true;
    }

    OnEndDrawing() {
        this.State.IsDrawing = false;
    }

    OnResizeWindow() {
        this.ResizePad();
    }

    OnOrientationChanged() {
        this.ResizePad();
    }

    ClearSignature() {
        if (!this.SignatureReadOnly) this.pad.clear();
    }

    IsEmpty = () => this.pad.isEmpty();

    Save() {
        this.State.SignatureData = this.pad.toDataURL();
    }

    ResizePad() {
        const width = this.ClientWidth;
        const height = this.ClientHeight;

        if (width) {
            this.pad.set('canvasWidth', width - 5);
        }

        if (height) {
            if (this.MaxSignatureHeight != 0 && height - this._areaAroundSize > this.MaxSignatureHeight) {
                this.pad.set('canvasHeight', this.MaxSignatureHeight);
            }
            else {
                this.pad.set('canvasHeight', height - this._areaAroundSize);
            }
        }
        
        this.LoadSignature()
    }

    private LoadSignature() {
        this.pad.clear();
        if (this.SignatureData != undefined) this.pad.fromDataURL(this.SignatureData, { ratio: 1 });
        if (this.SignatureReadOnly) this.pad.off();
    }
}
